'use client';

import { Session } from '@pickleballinc/lib/session';

import { NextSignedUpTourney } from '@/modules/players/v2/tabs/overview/NextSingedUpTourney';
import { PlayerData } from '@/types/players.types';
import { PlayerTournamentsData } from '@/types/playerTournaments.types';

type TournamentsWrapperProps = {
  player: PlayerData | undefined;
  upcomingTournaments: PlayerTournamentsData[];
  user?: Session;
};

export const TournamentsWrapper = ({ player, upcomingTournaments }: TournamentsWrapperProps) => {
  return (
    <div className='mt-16'>
      <div className='text-2xl font-bold text-gray-900'>
        Upcoming Pickleball Tournaments for {player?.firstName} {player?.lastNameAndSuffix}
      </div>
      <NextSignedUpTourney data={upcomingTournaments} player={player} />
    </div>
  );
};
